export default __webpack_public_path__ + "static/media/partner_img_02.ac90927d.svg";